"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCalenderObj = void 0;
var buildCalenderObj = function (from, inputRef, monthNumber, calender, setCalender) {
    // The buildCalenderObj function is used to generate an object representing the calendar for 
    // the current month, including the dates of the current, previous, and next months. 
    // This function is called whenever the value or from props change, which may happen when the user 
    // selects a new date or when the component is initially mounted.
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var date = from || new Date();
    var currentDate = new Date();
    var day = (((_c = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.split('/')[0]) === null || _c === void 0 ? void 0 : _c.length) > 1 &&
        ((_e = (_d = inputRef.current) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.split('/')[0])) ||
        date.getDate();
    var month = (((_g = (_f = inputRef.current.value) === null || _f === void 0 ? void 0 : _f.split('/')[1]) === null || _g === void 0 ? void 0 : _g.length) > 1 &&
        inputRef.current.value.split('/')[1]) ||
        date.getMonth();
    if (month == inputRef.current.value.split('/')[1]) {
        month--;
    }
    var year = (((_j = (_h = inputRef.current.value) === null || _h === void 0 ? void 0 : _h.split('/')[2]) === null || _j === void 0 ? void 0 : _j.length) > 3 &&
        inputRef.current.value.split('/')[2]) ||
        // calender?.year ||
        date.getFullYear();
    var customeDate = new Date(year, month + monthNumber, day);
    // last day date of the current month
    var lastDayDate = new Date(customeDate.getFullYear(), customeDate.getMonth() + 1, 0).getDate();
    // last day of the current month
    var lastDay = new Date(customeDate.getFullYear(), customeDate.getMonth() + 1, 0).getDay();
    //get last day of the previous month
    var lastDayPrev = new Date(customeDate.getFullYear(), customeDate.getMonth(), 0).getDate();
    var days = [];
    for (var i = 1; i <= lastDayDate; i++) {
        // days.push(i);
        var obj = new Date(customeDate.getFullYear(), customeDate.getMonth(), i);
        days.push(obj);
    }
    var prevDays = [];
    calender.today = customeDate.getDate();
    customeDate.setDate(1);
    for (var i = customeDate.getDay() - 1; i >= 0; i--) {
        var obj = new Date(customeDate.getFullYear(), customeDate.getMonth() - 1, lastDayPrev - i);
        prevDays.push(obj);
    }
    var nextDays = [];
    for (var i = 1; i < 7 - lastDay; i++) {
        var obj = new Date(customeDate.getFullYear(), customeDate.getMonth() + 1, i);
        nextDays.push(obj);
        // nextDays.push(i);
    }
    calender.days = days;
    calender.prevDays = prevDays;
    calender.nextDays = nextDays;
    calender.month = customeDate.getMonth();
    calender.year = customeDate.getFullYear();
    calender.todaysDate = currentDate;
    var modified = __assign({}, calender);
    setCalender(modified);
    return new Date(calender.year, calender.month, calender.today);
};
exports.buildCalenderObj = buildCalenderObj;
